import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BootstrapModal } from 'react-bootstrap5';

export default function Modal({
  show, size, animation, header, onHide, children, onExited,
}) {
  return (
    <BootstrapModal
      show={show}
      backdrop="static"
      keyboard={false}
      onHide={onHide}
      animation={animation}
      size={size}
      onExited={onExited}
    >
      {header && <BootstrapModal.Header closeButton>{header}</BootstrapModal.Header>}
      <BootstrapModal.Body>
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  animation: PropTypes.bool,
  onHide: PropTypes.func,
  onExited: PropTypes.func,
};

Modal.defaultProps = {
  size: null,
  header: null,
  animation: true,
  onHide: () => {},
  onExited: () => {},
};
